module.exports = __webpack_public_path__ + "4b584da5f76758e73a49dbf00d7c0457.pdf";